import React, { Component } from 'react';
import './styles/css/main.css';
import Wizard from './components/Wizard';
import SellingPage from './components/SellingPage'
import Config from './config.js'
import Colors from './styles/Colors'
import Styles from './styles/Styles'
import queryString from 'query-string'
import PdfViewer from './components/Pdf/PdfViewer'
import FilesListing from './components/Pdf/FilesListing'


class App extends Component {
  constructor(props) {
    super(props);

    const values = queryString.parse(this.props.location.search);
    let program = values.program?values.program:1;
    Config.program = Config.programs[program];
    Colors.Colors = Colors.allColors[Config.program.style];
    Styles.Style = Styles.allStyles[Config.program.style];
    Styles.activeStyle = Styles.inactiveStyle;
    console.log(Colors.Colors);
    console.log(Styles)

    this.state = {
      hasStarted: false,
    };
  }

  onStart = () => {
    this.setState({
      hasStarted: !this.state.hasStarted
    });

    // Set the scroll bar to the top
    window.scrollTo(0, 0);
  }

  renderFirstPage() {
    let firstPage = Config.program.firstPage;
    if (firstPage == "sellingPage") {
      return (
          <SellingPage onButtonClicked={this.onStart}/>
      );
    }
    else if (firstPage == "filesListing") {
      return (
          <FilesListing onButtonClicked={this.onStart}/>
      );
    }
  }

  renderWizard() {
    return (
      <div>
        <header style={Styles.Style.bgColorMain} className="heading">
          <span onClick={this.onStart} className="wizard-back"><i className="la la-angle-left"></i>Retour</span>
          <h1 className="heading-title wizard-title">Affiliation au programme {Config.program.programName}</h1>
        </header>
        <div className="wizard">
          <Wizard />
        </div>
      </div>
    );
  }

  render() {
    //return (<Pdf/>);
    return (
      <div>
        { this.state.hasStarted ? this.renderWizard() : this.renderFirstPage() }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js